<template>
  <div class="home">
    <div class="banner-frame">
      <swiper class="banner-bg" :options="swiperOption">
        <swiper-slide><img src="@/assets/home/swiper/1.jpg"></swiper-slide>
        <swiper-slide><img src="@/assets/home/swiper/2.png"></swiper-slide>
<!--        <swiper-slide><img src="@/assets/home/swiper/3.jpg"></swiper-slide>-->
<!--        <swiper-slide><img src="@/assets/home/swiper/4.jpg"></swiper-slide>-->
<!--        <swiper-slide><img src="@/assets/home/swiper/10.jpg"></swiper-slide>-->
        <swiper-slide><img src="@/assets/home/swiper/12.jpg"></swiper-slide>
<!--        <swiper-slide><img src="@/assets/home/swiper/13.jpg"></swiper-slide>-->
<!--        <swiper-slide><img src="@/assets/home/swiper/15.jpg"></swiper-slide>-->
<!--        <swiper-slide><img src="@/assets/home/swiper/16.jpg"></swiper-slide>-->
<!--        <swiper-slide><img src="@/assets/home/swiper/17.jpg"></swiper-slide>-->
      </swiper>
<!--      <swiper ref="mySwiper" class="banner-bg" :options="swiperOptions">-->
<!--        <swiper-slide style="height: 100%;"><img src="@/assets/home/bannerImg3.jpg"></swiper-slide>-->
<!--        <swiper-slide style="height: 100%;"><img src="@/assets/home/bannerImg4.jpg"></swiper-slide>-->
<!--      </swiper>-->
      <div class="banner-group">
        <template v-if="$i18n.locale=='zh'">
          <p class="banner-title">{{ $t('lang.home.bannerTitle') }}</p>
          <p class="banner-text">{{ $t('lang.home.bannerSubtitle') }}</p>
        </template>
        <template v-else>
          <p class="banner-title">{{ $t('lang.home.bannerTitle') }}</p>
          <p class="banner-title" style="font-size: 50px;">{{ $t('lang.home.bannerSubtitle') }}</p>
        </template>
      </div>
      <div class="search-box">
          <p @click="freightTates" class="select-btn">{{ $t('lang.home.inquiryBtn') }}</p>
          <p @click="cargoTracking" class="select-btn">{{ $t('lang.home.trackBtn') }}</p>
      </div>
    </div>
    <div class="intro-frame">
      <div>
        <img class="intro-img" src="../assets/home/southeast3.jpg" />
        <div class="intro-content">
          <p class="intro-title">{{ $t('lang.home.introTitle') }}</p>
          <p class="intro-text">{{ $t('lang.home.introText') }}</p>
        </div>
      </div>
      <div>
        <div class="intro-content intro-content2">
          <p class="intro-title">{{ $t('lang.home.valueTitle') }}</p>
          <p class="intro-text">{{ $t('lang.home.valueText') }}</p>
        </div>
        <img class="intro-img" src="../assets/home/699pic_04cl5c_xy2.jpg" />
      </div>
      <div>
        <img class="intro-img" src="../assets/home/southeast2.jpg" />
        <div class="intro-content intro-content3">
          <p class="intro-title">{{ $t('lang.home.serviceTitle') }}</p>
          <p class="intro-text">{{ $t('lang.home.serviceText') }}</p>
        </div>
      </div>
    </div>
    <!-- <div v-if="langType=='zh'" class="documents-frame">
      <img class="documents-bg" src="@/assets/home/documentsBg.png">
      <div class="documents-content">
        <p class="documents-text" style="text-align: center;font-size: 60px;">外贸单证小灵通</p>
        <p class="documents-text">外贸单据制作专家</p>
        <p @click="fabrication" class="documents-btn">一键制作外贸单据 >></p>
      </div>
    </div> -->
    <div class="relation-frame">
      <p class="relation-title">{{ $t('lang.home.contactTitle') }}</p>
      <div class="relation-way-frame">
        <div class="relation-way-group">
          <p class="relation-way-title">{{ $t('lang.home.addressLabel') }}</p>
          <p class="relation-way-text" v-html="$t('lang.home.address')"></p>
        </div>
        <div class="relation-way-group">
          <p class="relation-way-title">{{ $t('lang.home.telLabel') }}</p>
          <p class="relation-way-text">+86-21-63079687</p>
        </div>
        <div class="relation-way-group">
          <p class="relation-way-title">{{ $t('lang.home.faxLabel') }}</p>
          <p class="relation-way-text">+86-21-63090180</p>
        </div>
        <div class="relation-way-group">
          <p class="relation-way-title">{{ $t('lang.home.emailLabel') }}</p>
          <p class="relation-way-text">info@marshalfreight.net</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  components: {

  },
  data () {
    return {
      swiperOption: {
        autoplay: {
          delay: 8000
        },
        loop: true
      }
    }
  },
  watch: {
  },
  mounted () {
    this.$store.commit('setPageNow', 'Home')
  },
  methods: {
    fabrication () { // 一键制作外贸单据
      window.open('http://www.valavale.com')
    },
    cargoTracking () { // 货运跟踪
      this.$router.push({ path: '/freightTrack' })
    },
    freightTates () { // 运费查询
      this.$router.push({ path: '/freightTates' })
    }
  }
}
</script>
<style scoped>
  @font-face{
    font-family: 'fontsize1';
    src : url('../assets/font/fontsize1.woff');
  }
  @font-face{
    font-family: 'fontsize2';
    src : url('../assets/font/fontsize2.woff');
  }
  .banner-frame{
    position: relative;
    width: 1920px;
    height: 990px;
    overflow: hidden;
  }
  .banner-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .banner-bg img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .banner-group{
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 9;
  }
  .banner-title{
    text-align: center;
    font-size: 70px;
    font-family: fontsize3;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 70px;
  }
  @font-face{
    font-family: 'fontsize3';
    src : url('../assets/font/fontsize3.woff');
  }
  .banner-text{
    margin-top: 36px;
    font-size: 40px;
    font-family: fontsize3;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 40px;
  }
  .search-box{
    position: absolute;
    left: 50%;
    /*top: 60%;*/
    top: 78%;
    display: flex;
    transform: translateX(-50%);
    gap: 24px;
    width: auto;
    height: 88px;
    z-index: 9;
  }
  .intro-frame{
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 0 0;
  }
  .intro-img{
    width: 450px;
    height: 300px;
    object-fit: cover;
  }
  .intro-bg{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .intro-content{
    width: 450px;
    height: 300px;
    background-image: url("../assets/home/48c5056.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    padding: 40px 30px 48px;
    box-sizing: border-box;
    color: #fff;
  }
  .intro-content2{
    color: #18274e;
    background-image: url("../assets/home/e28e61d.jpg");
  }
  .intro-content3{
    background-image: url("../assets/home/img-index-07.jpg");
  }
  .intro-title{
    line-height: 30px;
    font-size: 20px;
    font-family: 微软雅黑;
    margin-bottom: 22px;
    font-weight: 400;
  }
  .intro-line{
    width: 120px;
    height: 4px;
    background: #FFFFFF;
    /*border-radius: 2px;*/
    margin-top: 40px;
    margin-bottom: 97px;
  }
  .intro-text{
    font-size: 16px;
    line-height: 1.8;
  }
  .idea-frame{
    position: relative;
    width: 1920px;
    height: 907px;
  }
  .idea-bg{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .idea-content{
    position: absolute;
    left: 79px;
    top: 0;
    width: 573px;
    height: 100%;
    background-color: #EB3C00;
    padding-left: 90px;
    box-sizing: border-box;
  }
  .idea-title{
    margin-top: 172px;
    font-size: 80px;
    font-family: fontsize3;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 80px;
  }
  .idea-line{
    width: 120px;
    height: 4px;
    background: #FFFFFF;
    /*border-radius: 2px;*/
    margin-top: 39px;
    margin-bottom: 100px;
  }
  .idea-text{
    width: 389px;
    height: 274px;
    font-size: 36px;
    font-family: fontsize2;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 60px;
  }
  .serve-frame{
    position: relative;
    width: 1920px;
    height: 706px;
  }
  .serve-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .serve-content{
    position: absolute;
    top: 0;
    right: 0;
    width: 702px;
    height: 100%;
    background-color: #24201C;
    padding-right: 136px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-direction: column;
  }
  .serve-title{
    margin-top: 106px;
    text-align: right;
    font-size: 80px;
    font-family: fontsize3;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 80px;
  }
  .serve-line{
    width: 120px;
    height: 4px;
    background: #008FD1;
    /*border-radius: 2px;*/
    margin-top: 40px;
    margin-bottom: 97px;
  }
  .serve-text{
    font-size: 36px;
    font-family: fontsize2;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 66px;
    text-align: right;
  }
  .documents-frame{
    position: relative;
    width: 1920px;
    height: 405px;
    background-color: #253551;
    margin-top: 80px;
  }
  .documents-bg{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .documents-content{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .documents-text{
    width: 600px;
    height: 80px;
    text-align: justify;
    font-size: 68px;
    font-family: SourceHanSansCN;
    font-weight: 800;
    color: #FFFFFF;
    line-height: 80px;
    margin: 0 auto;
  }
  .documents-text::after{
    content: '';
    display: inline-block;
    padding-left: 100%;
  }
  .documents-btn{
    margin: 32px auto 0;
    width: 320px;
    height: 60px;
    background: #008FD1;
    /*border-radius: 3px;*/
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
  }
  .relation-frame{
    width: 1920px;
    padding-bottom: 90px;
    box-sizing: border-box;
  }
  .relation-title{
    padding-top: 90px;
    font-size: 45px;
    font-family: fontsize3;
    font-weight: 400;
    color: #000;
    text-align: center;
  }
  .relation-way-frame{
    margin: 60px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 1400px;
  }
  .relation-way-group{
    position: relative;
    width: 342.5px;
    height: 230px;
    background-color: rgba(248, 248, 248, 1);
    transition: all 0.5s;
    padding: 25px;
    box-sizing: border-box;
    color: #333;
  }
  .relation-way-group:before{
    position: absolute;
    width: 58px;
    height: 58px;
    right: 20px;
    bottom: 20px;
    background: url('../assets/home/icon-lx-1.png') no-repeat center center;
    background-size: contain;
    content:"";
  }
  .relation-way-group:hover{
    background-color: #0061e3;
    color: #FFFFFF;
  }
  .relation-way-group:hover:before{
    background: url('../assets/home/icon-lx-1s.png') no-repeat center center;
    background-size: contain;
  }
  .relation-way-group:nth-child(2):before,.relation-way-group:nth-child(3):before{
    width: 64px;
    background: url('../assets/home/icon-lx-2.png') no-repeat center center;
  }
  .relation-way-group:nth-child(2):hover:before,.relation-way-group:nth-child(3):hover:before{
    background: url('../assets/home/icon-lx-2s.png') no-repeat center center;
    background-size: contain;
  }
  .relation-way-group:nth-child(4):before{
    background: url('../assets/home/icon-lx-4.png') no-repeat center center;
  }
  .relation-way-group:nth-child(4):hover:before{
    background: url('../assets/home/icon-lx-4s.png') no-repeat center center;
    background-size: contain;
  }
  .relation-way-title{
    font-size: 20px;
    padding-bottom: 10px;
    font-family: fontsize1;
    font-weight: 600;
  }
  .relation-way-text{
    font-size: 16px;
    font-family: fontsize2;
  }
  .select-btn{
    min-width: 240px;
    padding: 0 40px;
    box-sizing: border-box;
    height: 88px;
    border: none;
    border-radius: 54px;
    background: linear-gradient(135deg, #1a73e8 0%, #1976d2 100%);
    box-shadow: 0 18px 38px rgba(26, 118, 210, 0.28);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-family: fontsize3;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 1;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;
  }
  .select-btn:hover{
    transform: translateY(-4px);
    box-shadow: 0 22px 44px rgba(26, 118, 210, 0.32);
  }
  .select-btn:active{
    transform: translateY(-1px);
    box-shadow: 0 12px 24px rgba(26, 118, 210, 0.3);
    filter: brightness(0.95);
  }
</style>
